/**
 * === BLAZE CHANGE ===
 * File added for Blaze geolocation/currency overlay ONLY.
 * Do not remove without checking with Blaze.
 *
 * Desktop: move Blaze switcher from header RIGHT (cart) to LEFT.
 * Mobile/tablet: leave Blaze on footer utilities (.blz_selector_mobile).
 */
(function () {
  'use strict';

  var SELECTOR = '.blz-overlay_selector_container';
  var LEFT_COL = '.header__column--left';
  var RIGHT_COL = '.header__column--right';
  var MARK = 'data-blaze-change-moved-left';
  var debounceTimer = null;

  function isMobileOrTablet() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function isInFooter(el) {
    if (!el) return false;
    if (el.closest('.footer-utilities, .blz_selector_mobile, .shopify-section-group-footer-group, footer')) {
      return true;
    }
    var prev = el.previousElementSibling;
    if (
      prev &&
      (prev.id === 'shopify-section-sections--22434189967559__utilities' ||
        prev.classList.contains('footer-utilities') ||
        prev.classList.contains('blz_selector_mobile'))
    ) {
      return true;
    }
    return false;
  }

  function moveBlazeSwitcherToLeft() {
    // Mobile/tablet: Blaze footer anchor — do not move into header
    if (isMobileOrTablet()) return;

    var leftCol = document.querySelector(LEFT_COL);
    if (!leftCol) return;

    var switchers = document.querySelectorAll(SELECTOR);
    if (!switchers.length) return;

    switchers.forEach(function (el) {
      if (isInFooter(el)) return;
      if (!el.closest(RIGHT_COL)) return;

      leftCol.appendChild(el);
      el.setAttribute(MARK, 'true');
    });
  }

  function schedule() {
    if (debounceTimer) window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(moveBlazeSwitcherToLeft, 100);
  }

  function start() {
    moveBlazeSwitcherToLeft();

    if (!document.body) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var added = m.addedNodes[j];
            if (added.nodeType !== 1) continue;
            if (
              (added.matches && added.matches(SELECTOR)) ||
              (added.querySelector && added.querySelector(SELECTOR))
            ) {
              schedule();
              return;
            }
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
